import { render, staticRenderFns } from "./ImageResizer.vue?vue&type=template&id=70c40ae8&"
import script from "./ImageResizer.vue?vue&type=script&lang=js&"
export * from "./ImageResizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports